export const employeePaths = {
  INDEX: '/',
}
